import { CheckCircle, Clock } from 'lucide-react';
import { useHistory } from 'react-router-dom';

export const ResetPasswordSuccess = ({
  email,
  onResendMail,
  handleGoToLogin
}: {
  email: string;
  onResendMail: () => void;
  handleGoToLogin?: () => void;
}): JSX.Element => {
  const history = useHistory();

  const handleBack = handleGoToLogin ?? (() => history.push('/login'));

  return (
    <>
      <div className="flex flex-col gap-[11px]">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-onboarding-success-light text-onboarding-success">
          <CheckCircle className="h-7 w-7" />
        </span>
        <h1 className="font-onboarding-1 text-[2rem] font-bold leading-[1.04] tracking-[-0.025em] text-primary min-[880px]:text-[2.35rem]">
          Check your email
        </h1>
        <p className="text-[15.5px] leading-[1.5] text-[var(--ink-2)]">
          If <span className="font-semibold text-[var(--ink)]">{email}</span> is registered, you&apos;ll receive a
          password reset link shortly.
        </p>
      </div>

      <div className="rounded-[12px] border border-[var(--line)] bg-[var(--sunken)] p-4 text-left">
        <h3 className="mb-2 text-[14px] font-semibold text-[var(--ink)]">Next steps</h3>
        <ol className="space-y-1 text-[13px] text-[var(--ink-2)]">
          <li>1. Check your email inbox</li>
          <li>2. Click the secure reset link</li>
          <li>3. Create your new password</li>
          <li>4. Sign in with 2FA verification</li>
        </ol>
      </div>

      <div className="rounded-[12px] border border-brand-orange/30 bg-brand-gold-50 p-4">
        <div className="mb-1 flex items-center space-x-2 text-brand-orange">
          <Clock className="h-4 w-4" />
          <span className="text-[13px] font-medium">Link expires in 15 minutes</span>
        </div>
        <p className="text-[12px] text-brand-orange/80">For security, the reset link will expire automatically.</p>
      </div>

      <button
        type="button"
        onClick={() => handleBack()}
        className="btn-cta-orange flex h-12 w-full items-center justify-center rounded-lg text-[15px] font-semibold text-white transition disabled:cursor-not-allowed disabled:opacity-50"
      >
        Return to log in
      </button>

      <button
        type="button"
        onClick={() => onResendMail()}
        className="flex h-12 w-full items-center justify-center rounded-[12px] border border-[var(--line)] bg-surface text-[15px] font-semibold text-[var(--ink)] transition hover:border-[var(--line-2)] hover:bg-[var(--sunken)]"
      >
        Resend email
      </button>

      <p className="text-[13px] text-[var(--ink-3)]">
        Didn&apos;t receive the email? Check your spam folder or contact support.
      </p>
    </>
  );
};
